import React from 'react';

import { sendEventClick } from 'src/api/tracker';

import toolsPropTypes from 'src/types/toolsPropTypes';

import ToolsBox from 'src/components/ToolsBox';

import 'src/containers/ToolsBoxWrapper.scss';

const ToolsBoxWrapper = ({ tools }) => (
  <div styleName="tools-box-wrapper">
    {tools.map(({ id, title, link, icon, subtitle, testName }) => (
      <ToolsBox
        key={title}
        icon={icon}
        link={link}
        subtitle={subtitle}
        testName={testName}
        title={title}
        onClick={() => {
          sendEventClick(`tools_${id}`);
        }}
      />
    ))}
  </div>
);

ToolsBoxWrapper.propTypes = toolsPropTypes;

export default ToolsBoxWrapper;
